'use client';

import React, { useMemo } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCheck, faPencil } from '@fortawesome/pro-solid-svg-icons';
import useTableFilterSelections from 'src/hooks/filters/useTableFilterSelections';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import { useEditDrawerData } from 'src/hooks/common/useEditDrawerData';
import { FilterSet } from 'src/components/TableDrawers/components/types';
interface SectionItemProps {
  item: any;
  location: string;
}

const SectionItem = ({ item, location }: SectionItemProps) => {
  const { closeAllButCurrent } = useDrawer();
  // Use the item's type (professional, education, salesEnablement) as the filter type
  const filterType = item?.type?.toLowerCase();
  const { getTempFilterSetId } = useTableFilterSelections();
  const { setCurrentFilterSetData } = useEditDrawerData();
  const selectedFilterSetIds = getTempFilterSetId(filterType);

  const handleToggleFilterSet = (_filterSet: FilterSet) => {
    // TODO: implement toggle behavior
  };

  const handleEditFilterSet = (
    e: React.MouseEvent<HTMLDivElement>,
    filterSet: FilterSet
  ) => {
    e.stopPropagation();
    setCurrentFilterSetData(filterSet);
    closeAllButCurrent(`editFilterDrawer-${location}`);
  };

  const isItemSelected = useMemo(() => {
    return selectedFilterSetIds.includes(item?.id);
  }, [item, selectedFilterSetIds]);

  return (
    <div
      className="group self-stretch px-4 py-2 hover:bg-level-1 inline-flex justify-start items-center gap-2 cursor-pointer"
      onClick={() => handleToggleFilterSet(item)}
    >
      <div
        className={`w-5 h-5 overflow-hidden flex items-center justify-center
          ${isItemSelected ? 'opacity-100' : 'opacity-0'}
        `}
      >
        <Icon icon={faCheck} className="w-3.5 h-2.5 text-neutral-600" />
      </div>
      <div className="flex-1 justify-start text-primary text-base font-normal font-['Inter'] leading-normal">
        {item.label}
      </div>
      {/* TODO: implement copy behavior */}
      {/* <div className="w-5 h-5 overflow-hidden flex items-center justify-center opacity-0 group-hover:opacity-100">
        <Icon icon={faCopy} className="w-3.5 h-4 text-neutral-400" />
      </div> */}
      <div
        className="w-5 h-5 overflow-hidden flex items-center justify-center opacity-0 group-hover:opacity-100 cursor-pointer"
        onClick={(e) => handleEditFilterSet(e, item)}
      >
        <Icon icon={faPencil} className="w-3.5 h-3.5 text-neutral-400" />
      </div>
    </div>
  );
};

export default SectionItem;
